/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBounceRight = createReactComponent("outline", "bounce-right", "IconBounceRight", [["path", { "d": "M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8", "key": "svg-0" }], ["path", { "d": "M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z", "key": "svg-1" }]]);

export { IconBounceRight as default };
//# sourceMappingURL=IconBounceRight.mjs.map
